import React, { useState, useEffect, useMemo } from "react"
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import ReactFancyBox from 'react-fancybox'
import 'react-fancybox/lib/fancybox.css'

function GallerySection(props) {
    function setphoneValue(e) {
        Fancybox.bind("[data-fancybox]", {
            Image: {
                Panzoom: {
                    zoomFriction: 0.7,
                    maxScale: function () {
                        return 5;
                    },
                },
            },
        });
    }

    const { t, i18n } = useTranslation('common');
    const [galleryData, setgallerys_url] = useState('');
    useEffect(() => {
        if (props?.lan == 'en') {
            i18next.changeLanguage("en");
        } else {
            i18next.changeLanguage("el");
        }
        

            setgallerys_url(props.gallery_data);
        
    }, [])
   
    return (<section class="gallery_section rem_gallery_section rem_nav_section" id="gallery_section">
        <div class="container_size">
            <h3 class="gallery_heading">{t('Gallery')}</h3>
            <div class="list-gallery" id="myHeader">
                <button class="btn rem_gallery_btns" data-index="all" data-show=".all-project">All</button>


                {(galleryData) ? galleryData.map(function (gallery_val, i) {

                    return (<button class="btn rem_gallery_btns" data-index={i} data-show=".team_project">{(gallery_val?.title) ? gallery_val?.title : ''}</button>);
                }) : ''}
            </div>

            <div class="row rem_gallery" id="rem_gallery_all">
                <div class="all-project same_project">
                    <div class="column">
                        {(galleryData) ? galleryData.map(function (gallery_val, i) {
  
                            {
                                return (gallery_val?.images) ? gallery_val?.images.map(function (gallery_image, i) {
                                  
                                    return (

                                        <div class="" onClick={setphoneValue}>


                                            <div class="flex flex-wrap gap-5 justify-center max-w-5xl mx-auto px-6">
                                         
                                                <a data-fancybox="gallery" href={gallery_image} data-width="1200" data-height="900">
                                                <img src={(gallery_image) ? gallery_image : ''} alt="" />
                                                </a>
                                               
                                                
                                            </div>

     



                                        </div>

                                    );
                                }) : ''
                            }
                        }) : ''}
                    </div>
                </div>

            </div>

            {(galleryData) ? galleryData.map(function (gallery_val, i) {

                {
                    return <div class="row rem_gallery rem_tab_gallery " id={'rem_gallery_' + i} >

                        <div class="same_project">
                            <div class="column">{(gallery_val?.images) ? gallery_val?.images.map(function (gallery_image, i) {
                                return (

                                    <div class=""  onClick={setphoneValue}>

<a data-fancybox="gallery" href={gallery_image} data-width="1200" data-height="900">
                                            <img data- src={(gallery_image) ? gallery_image : ''} alt="" />
                                        </a>


                                    </div>

                                );
                            }) : ''}</div>
                        </div>

                    </div>
                }
            }) : ''}


        </div>
    </section>);
}

export default GallerySection;